/**
 * Stable `data-testid` hooks shared across flower and template catalog pages.
 * Used by Playwright to scope clicks below sticky event-type tabs (see
 * `e2e/sticky-footer-registry.ts`).
 */
export const CATALOG_CARD_GRID_TEST_ID = 'catalog-card-grid';

/**
 * Bottom Total row of every checkout price summary (`PriceSummaryTotalLine`).
 * Playwright scopes to this instead of text, because review cards also show an "Order total" heading.
 */
export const PRICE_SUMMARY_TOTAL_LINE_TEST_ID = 'price-summary-total-line';
